import React from 'react';
import classNames from 'classnames';
import styled, { css } from 'styled-components';

// components
import { SpacingProps } from '../box';
import { deviceSizes, spacing } from '../../style';
import { withSpacing } from '../../utils/with-spacing';
import { CssUnitsAsResponsiveObject } from '../../utils/get-css-rule-with-responsive-calc';
import { sizes } from './style';

export interface ContainerProps extends SpacingProps {
  children?: React.ReactNode;
  className?: string;
  size?: keyof typeof sizes;
  center?: boolean;
  style?: React.CSSProperties;
  display?: CssUnitsAsResponsiveObject<React.CSSProperties['display']>;
  flex?: React.CSSProperties['flex'];
  flexDirection?: React.CSSProperties['flexDirection'];
  height?: string;
  'data-testid'?: string;
  overflowY?: 'auto' | 'scroll';
}

const DEFAULT_SIZE = 'lg';

export const Container = styled(
  ({ className, children, size = DEFAULT_SIZE, center = true, style, 'data-testid': dataTestId }: ContainerProps) => (
    <div style={style} className={classNames('box-container', className, size, { center })} data-testid={dataTestId}>
      {children}
    </div>
  ),
)<ContainerProps>`
  height: ${props => props.height};
  overflow-y: ${props => props.overflowY};
  width: 100%;
  display: ${props => props.display};
  flex: ${props => props.flex};
  flex-direction: ${props => props.flexDirection};

  ${withSpacing};

  ${({ size = DEFAULT_SIZE }) => css`
    padding-right: ${spacing.sm};
    padding-left: ${spacing.sm};

    @media (min-width: ${deviceSizes.md}) {
      max-width: ${sizes[size].md.width};
    }

    @media (min-width: ${deviceSizes.lg}) {
      max-width: ${sizes[size].lg.width};
    }

    @media (min-width: ${deviceSizes.xl}) {
      max-width: ${sizes[size].xl.width};
    }
  `};

  &.center {
    margin-right: auto;
    margin-left: auto;
  }
`;

export default Container;
